import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";
import {PopupType} from "../popups/popupType";
import {EstimateDeletePopupParams} from "../../components/estimate-delete-popup/estimate-delete-popup";

export class RemoveCurrentEstimateCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.RemoveCurrentEstimate;
    
    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();
        
        if(!estimate)
            return false;
        
        return true;
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();
        
        let estimate = this.app.state.estimate();

        let params = <EstimateDeletePopupParams> {
            id: estimate!.id(),
        };

        return this.app.popupsManager.show<EstimateDeletePopupParams>(PopupType.deleteEstimate, true, params).done(() => {
            this.app.state.estimate(undefined);
            this.app.state.estimateLoading(false);
        });

    }

    name = "Delete estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/removeCurrentEstimateCommand.ts